import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ps-1 me-1 ms-1 mt-4 mb-0 control-search-box-table-input d-flex" }
const _hoisted_2 = {
  class: "control-search-box-general-filter",
  style: {"cursor":"pointer"}
}
const _hoisted_3 = { class: "icon is-small is-left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.gotToSearchPageFromSubmmit && _ctx.gotToSearchPageFromSubmmit(...args)), ["prevent"])),
    class: "w-100 align-content-center"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_input, {
        style: {"max-height":"70% !important"},
        class: "mt-0 mb-0 w-100",
        modelValue: _ctx.inputInformation,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputInformation) = $event)),
        placeholder: "Title of the research",
        name: "title"
      }, null, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, [
          _createElementVNode("i", {
            class: "fas fa-search",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.gotToSearchPage(_ctx.inputInformation)))
          })
        ])
      ])
    ])
  ], 32))
}